import { type } from "arktype";

import type { Draft } from "./fields";

const DRAFT_KEY = "cadastro:draft:v1";

const storedSchema = type("string.json.parse").to({
	draft: "Record<string, string>",
	step: "number.integer >= 0 = 0",
});

interface StoredDraft {
	draft: Draft;
	step: number;
}

function safeRead(key: string) {
	try {
		return localStorage.getItem(key);
	} catch {
		return null;
	}
}

function safeWrite(key: string, value: string) {
	try {
		localStorage.setItem(key, value);
	} catch {}
}

function safeRemove(key: string) {
	try {
		localStorage.removeItem(key);
	} catch {}
}

export const DraftStorage = {
	load(): StoredDraft | null {
		const raw = safeRead(DRAFT_KEY);

		if (raw === null) {
			return null;
		}

		const parsed = storedSchema(raw);

		if (parsed instanceof type.errors) {
			return null;
		}

		return parsed;
	},

	save(stored: StoredDraft) {
		safeWrite(
			DRAFT_KEY,
			JSON.stringify({ ...stored, draft: { ...stored.draft, photo: undefined } }),
		);
	},

	clear() {
		safeRemove(DRAFT_KEY);
	},

	hasContent(draft: Draft) {
		return Object.values(draft).some((v) => typeof v === "string" && v.trim() !== "");
	},
};
